import apolloClient from '../../utils/apollo-client';
import { acceptQuoteMutation } from '../../api/graphql/quote';

export default async function acceptQuote(payLoad) {
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation: acceptQuoteMutation,
      variables: { payLoad }
    })
  );
  return response.data.acceptQuote;
}
